/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetLastOpenShiftMovements200ResponseMovementsInner
 */
export interface GetLastOpenShiftMovements200ResponseMovementsInner {
    /**
     * 
     * @type {string}
     * @memberof GetLastOpenShiftMovements200ResponseMovementsInner
     */
    method?: string;
    /**
     * 
     * @type {Date}
     * @memberof GetLastOpenShiftMovements200ResponseMovementsInner
     */
    creationTime: Date;
    /**
     * 
     * @type {number}
     * @memberof GetLastOpenShiftMovements200ResponseMovementsInner
     */
    diff: number;
    /**
     * 
     * @type {string}
     * @memberof GetLastOpenShiftMovements200ResponseMovementsInner
     */
    detail?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLastOpenShiftMovements200ResponseMovementsInner
     */
    tabCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetLastOpenShiftMovements200ResponseMovementsInner
     */
    tableName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLastOpenShiftMovements200ResponseMovementsInner
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof GetLastOpenShiftMovements200ResponseMovementsInner
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof GetLastOpenShiftMovements200ResponseMovementsInner
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLastOpenShiftMovements200ResponseMovementsInner
     */
    locationId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetLastOpenShiftMovements200ResponseMovementsInner
     */
    manualMovement?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetLastOpenShiftMovements200ResponseMovementsInner
     */
    tillId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLastOpenShiftMovements200ResponseMovementsInner
     */
    tabId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetLastOpenShiftMovements200ResponseMovementsInner
     */
    paymentId?: string | null;
}

/**
 * Check if a given object implements the GetLastOpenShiftMovements200ResponseMovementsInner interface.
 */
export function instanceOfGetLastOpenShiftMovements200ResponseMovementsInner(value: object): value is GetLastOpenShiftMovements200ResponseMovementsInner {
    if (!('creationTime' in value) || value['creationTime'] === undefined) return false;
    if (!('diff' in value) || value['diff'] === undefined) return false;
    return true;
}

export function GetLastOpenShiftMovements200ResponseMovementsInnerFromJSON(json: any): GetLastOpenShiftMovements200ResponseMovementsInner {
    return GetLastOpenShiftMovements200ResponseMovementsInnerFromJSONTyped(json, false);
}

export function GetLastOpenShiftMovements200ResponseMovementsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLastOpenShiftMovements200ResponseMovementsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'method': json['method'] == null ? undefined : json['method'],
        'creationTime': (new Date(json['creationTime'])),
        'diff': json['diff'],
        'detail': json['detail'] == null ? undefined : json['detail'],
        'tabCode': json['tabCode'] == null ? undefined : json['tabCode'],
        'tableName': json['tableName'] == null ? undefined : json['tableName'],
        'id': json['id'] == null ? undefined : json['id'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'locationId': json['locationId'] == null ? undefined : json['locationId'],
        'manualMovement': json['manualMovement'] == null ? undefined : json['manualMovement'],
        'tillId': json['tillId'] == null ? undefined : json['tillId'],
        'tabId': json['tabId'] == null ? undefined : json['tabId'],
        'paymentId': json['paymentId'] == null ? undefined : json['paymentId'],
    };
}

export function GetLastOpenShiftMovements200ResponseMovementsInnerToJSON(json: any): GetLastOpenShiftMovements200ResponseMovementsInner {
    return GetLastOpenShiftMovements200ResponseMovementsInnerToJSONTyped(json, false);
}

export function GetLastOpenShiftMovements200ResponseMovementsInnerToJSONTyped(value?: GetLastOpenShiftMovements200ResponseMovementsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'method': value['method'],
        'creationTime': ((value['creationTime']).toISOString()),
        'diff': value['diff'],
        'detail': value['detail'],
        'tabCode': value['tabCode'],
        'tableName': value['tableName'],
        'id': value['id'],
        'amount': value['amount'],
        'userId': value['userId'],
        'locationId': value['locationId'],
        'manualMovement': value['manualMovement'],
        'tillId': value['tillId'],
        'tabId': value['tabId'],
        'paymentId': value['paymentId'],
    };
}

